import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {createDefaultDialogConfig} from '../../common/dialog-utils';
import {filter} from 'rxjs/operators';
import {TranslateModule} from '@ngx-translate/core';
import { ConfirmationDialogSvgSpriteComponent } from './confirmation-dialog-svg-sprite.component';
import { CloseDialogCrossIconSvgComponent } from '../../svg-sprites/general/close-dialog-cross-icon-svg.component';

@Component({
    selector: 'confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    imports: [
        TranslateModule,
        ConfirmationDialogSvgSpriteComponent,
        CloseDialogCrossIconSvgComponent
    ]
})

export class ConfirmationDialogComponent {
  title:string;
  confirmationText:string;
  leftButtonText:string;
  rightButtonText:string;
  isTitleTrashIconEnabled:boolean;

  constructor (
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.title = data.title;
    this.confirmationText = data.confirmationText;
    this.leftButtonText = data?.leftButtonText;
    this.rightButtonText = data?.rightButtonText;
    this.isTitleTrashIconEnabled = data?.isTitleTrashIconEnabled ? data?.isTitleTrashIconEnabled : false;
  }

  cancel() {
    this.dialogRef.close({confirm:false});
  }

  confirm() {
    this.dialogRef.close({confirm:true});
  }
}

export function openConfirmationDialog(
  dialog: MatDialog,
  title:string,
  confirmationText:string,
  leftButtonText?: string,
  rightButtonText?: string,
  isTitleTrashIconEnabled?: boolean,
) {

  const config = createDefaultDialogConfig();

  config.maxWidth = '490px';
  config.maxHeight = '95vh';

  config.data = {
    title,
    confirmationText,
    leftButtonText,
    rightButtonText,
    isTitleTrashIconEnabled
  };

  const dialogRef = dialog.open(ConfirmationDialogComponent, config);

  return dialogRef.afterClosed().pipe(
    filter(val => !!val),
  );
}
